<svg [class]="'cabinet-icon-svg ' + size">
  <use
    [attr.xlink:href]="'/assets/icons.svg#' + iconName"
    [attr.href]="'/assets/icons.svg#' + iconName"
  />
</svg>
